import { render } from "./FeedbackPage.vue?vue&type=template&id=76360f60&scoped=true"
import script from "./FeedbackPage.vue?vue&type=script&lang=js"
export * from "./FeedbackPage.vue?vue&type=script&lang=js"

import "./FeedbackPage.vue?vue&type=style&index=0&id=76360f60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76360f60"]])

export default __exports__